import { render } from "./RetailPiazzaAssetType.vue?vue&type=template&id=17685578"
import script from "./RetailPiazzaAssetType.vue?vue&type=script&lang=js"
export * from "./RetailPiazzaAssetType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__